import { Injectable } from '@angular/core';
import { Http, Headers, Response, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map'
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Rx';
import { Credential } from '../login/credential.model';
import { AppConfig } from '../../app.config';

@Injectable()
export class AuthenticationService {
    private headers: Headers;
    private authToken: string;
    private options: RequestOptions;

    constructor(private http: Http, private router: Router) {
        this.headers = new Headers();
        this.headers.append('Content-Type', 'application/json');
        this.headers.append('Accept', 'application/json');
        this.options = new RequestOptions({ headers: this.headers });
    }

    login(credential: Credential): Observable<any> {
        let requestData = JSON.stringify(credential);
        var baseURL = AppConfig.serverWithApiUrl + "auth";

        sessionStorage.removeItem("token");

        return this.http.post(baseURL, requestData, this.options)
            .map((response: Response) => {
                var payload = response.json()
                var authorization = response.headers.get('Authorization');
                sessionStorage.setItem("token", authorization);
                return payload;
            }).catch(this.handleError);
    }

    verifyCode(code: string): Observable<any> {
        var baseURL = AppConfig.serverWithApiUrl + "auth/2fa";

        let token = sessionStorage.getItem("token") || null;

        let headers = new Headers();
        headers.append('Content-Type', 'application/json');
        headers.append('Authorization', 'Bearer ' + token);

        let options = new RequestOptions({ headers: headers });

        let requestData = {
            code: code
        }

        return this.http.post(baseURL, requestData, options)
            .map((response: Response) => {
                return response;
            }).catch(this.handleError);
    }

    private handleError(error: Response | any) {
        return Observable.throw(error);
    }

    /** 
         * // Encodes the parameters. 
         * 
         * @param params The parameters to be encoded 
         * @return The encoded parameters 
         */
    private encodeParams(params: any): string {
        let body: string = "";
        for (let key in params) {
            if (body.length) {
                body += "&";
            }
            body += key + "=";
            body += encodeURIComponent(params[key]);
        }
        return body;
    }

    logout(): void {
        console.log(this.router);
        this.router.navigate(['/login']);
    }
}


// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/sms-server-fe-release-v2.1.8.3/src/app/pages/login/authentication.service.ts